/* eslint-disable @typescript-eslint/naming-convention */
import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {AccessType, Role} from '@app/modules/shared/data/constants';
import {LocalUser, LocalUserAction, LocalUserState} from '@app/state/local-user.state';
import {Store} from '@ngxs/store';
import {VcrEntity} from '@app/models/vcr-entity/entity';
import {FormControl, FormGroup} from '@angular/forms';
import {AppBaseInfo} from '@app/models/vcr-entity/app-base-info';
import {User} from '@app/models/vcr-entity/user';
import {LoginService} from '@app/modules/auth/services/login.service';
import {ClassroomState, ClassroomStateModel} from '@app/state/classroom-state.service';
import {SmartsuppService} from '@app/modules/shared/services/smartsupp.service';
import {HttpClient, HttpStatusCode} from '@angular/common/http';
import {ClassroomInitService} from '@app/modules/shared/services/classroom-init.service';
import {UtilService} from '@app/modules/shared/services/util.service';
import {
  RemoteUserAdditionalInfoStateModel,
  RemoteUserInfoStateModel,
  RemoteUsersInfoState
} from '@app/state/remote-users.state';
import {CoreService} from '@app/services/core.service';
import {Observable} from 'rxjs';

@Component({
  selector: 'app-login-details',
  templateUrl: './login-details.component.html',
  styleUrls: ['./login-details.component.css']
})
export class LoginDetailsComponent implements OnInit {
  public localUser: LocalUser;
  private remoteUsers: { [key: number]: RemoteUserAdditionalInfoStateModel } = {};
  public classroom: ClassroomStateModel;
  public teachersWarning: string;
  public noAccessWarning: string;
  public smartsuppUsername: string;
  public onlineTeachers: User[] | undefined = undefined;
  public accessTypes = Object.keys(AccessType);
  public form = new FormGroup({
    selectedRoleType: new FormControl(AccessType.TEACHER)
  });
  public UtilService = UtilService;

  protected readonly window: Window = window;

  constructor(
    private loginService: LoginService,
    private smartsuppService: SmartsuppService,
    private classroomInitService: ClassroomInitService,
    private coreService: CoreService,
    private router: Router,
    private http: HttpClient,
    private store: Store
  ) {
    this.listenStoreChanges();
  }

  public ngOnInit(): void {
    this.smartsuppUsername = this.smartsuppService.buildUsername(false);

    if (this.localUser.role === Role.STAFF || this.localUser.role === Role.STAFF_ADMIN) {
      this.getOnlineTeachers().subscribe((result: any) => {
        this.onlineTeachers = result.data;
        const teachersNames: string[] = this.onlineTeachers.map((teacher: User) => teacher.firstName + ' ' + teacher.lastName);

        if (teachersNames.length > 0) {
          this.noAccessWarning = undefined;
          this.teachersWarning = `Class is in session, please be careful not to interrupt! Teacher: ${teachersNames.join(', ')}.`;
        }
      });
    }
  }

  public selectAccessType(): void {
    this.loginService.selectAccessType(this.form.controls.selectedRoleType.value).subscribe(result => {
      const appBaseInfo: AppBaseInfo = VcrEntity.createEntity(AppBaseInfo, result.data);
      appBaseInfo.sessionUser = VcrEntity.createEntity(User, appBaseInfo.sessionUser);
      this.store.dispatch(new LocalUserAction.SetLocalUserAccessType(appBaseInfo.sessionUser.accessType));
      this.store.dispatch(new LocalUserAction.SetLocalUserIdentity(appBaseInfo.sessionUser.identity));

      if (!appBaseInfo.roomNum) {
        this.router.navigateByUrl(`/incorrect-url`).then();
      } else {
        console.warn(result.message);
      }

      this.classroomInitService.navigateToHome();
    }, error => {
      switch (error.status) {
        case HttpStatusCode.Forbidden:
          this.router.navigateByUrl(`/${this.classroom.roomNum}/login`).then();
          break;
        case HttpStatusCode.NotAcceptable:
          this.teachersWarning = undefined;
          this.noAccessWarning = `You cannot login as ${this.form.controls.selectedRoleType.value}, classroom is closed.`;
          break;
      }
    });
  }

  public getOnlineTeachers(): Observable<any> {
    return this.http.get(`${this.classroom.vcrURL}/classroom/online-teachers`);
  }

  private listenStoreChanges(): void {
    this.store.select(LocalUserState).subscribe((localUser: LocalUser) => {
      this.localUser = localUser;
    });
    this.store.select(RemoteUsersInfoState).subscribe(({usersInfoById}: RemoteUserInfoStateModel) => {
      this.remoteUsers = usersInfoById;
    });
    this.store.select(ClassroomState).subscribe((classroom: ClassroomStateModel) => {
      this.classroom = classroom;
    });
  }
}
